import React, { useEffect, useState } from 'react'
import AssessmentWrapper from '../../AssessmentWrapper'
import { Modal } from "antd";
import Close from "../../../../resources/imgs/modal/close.svg";
import { FaChevronRight } from "react-icons/fa";
import { useRecoilValue } from 'recoil'
import { assessmentAtom } from "../../../../state/assessment";
import { addAssessment } from '../../../../services/assessment';
import Progress from "../../progress";
import HelpBtn from "../../../../resources/imgs/assessment/helpBtn.svg"

var initialRes = {
  module: 4,
  moduleKey: "name_recall",
  B_nameRecognition: []
}

// Static list of common names for Module 4B
const COMMON_NAMES = [
  "Michael",
  "Jessica",
  "David",
  "Emily",
  "John",
  "Sarah",
  "Robert",
  "Linda",
  "James",
  "Karen",
  "Daniel",
  "Lisa",
  "William",
  'Barbara',
  "Joseph",
  "Nancy",
  "Thomas",
  "Betty",
  "Christopher",
  "Margaret",
  'Anthony',
  "Sandra",
  "Matthew",
  "Ashley",
  "Mark",
  "Kimberly",
  "Donald",
  "Donna",
  "Steven",
  "Carol",
  "Paul",
  "Michelle",
  "Andrew",
  "Dorothy",
  "Kenneth",
  "Amanda",
  "Joshua",
  "Melissa",
  "Kevin",
  "Deborah",
  "Brian",
  "Stephanie",
  "George",
  "Rebecca",
  "Edward",
  "Laura",
  "Ronald",
  "Sharon",
  "Timothy",
  "Cynthia"
];

// Updated Module 4-4 with cognitive scoring (Module 4B)
function Module4_4Content({ nextPage, recordScore, cardData, handleModuleComplete }) {
  const assessment = useRecoilValue(assessmentAtom);
  const [selectedNames, setSelectedNames] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [problemNames, setProblemNames] = useState([]);
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    console.log('🔍 Module4B useEffect called with cardData:', cardData);
    
    // Reset initialRes when component mounts
    initialRes.B_nameRecognition = [];
    
    if (!cardData || cardData.length === 0) {
      console.log('⚠️ Module4B: No cardData available yet');
      return;
    }

    const tempProblemNames = [];
    
    // Handle both formats: array of objects with name property, or array of strings
    const guestNames = typeof cardData[0] === 'string' 
      ? cardData 
      : cardData.map(guest => guest.name);
    
    for (let i = 0; i < 6; i++) {
      let temp = [guestNames[i]];
      let a = shuffleArray(COMMON_NAMES).slice(0, 2);
      temp = shuffleArray([...temp, ...a])
      tempProblemNames.push(temp);
    }

    for (let i = 0; i < 6; i++) {
      tempProblemNames.push(shuffleArray(COMMON_NAMES).slice(0, 3));
    }

    const shuffledProblems = shuffleArray(tempProblemNames);
    setProblemNames(shuffledProblems);
    setSelectedNames(shuffledProblems[0]);
    console.log('🔍 Module4B: Generated problems:', shuffledProblems);
  }, [cardData]); // Removed 'names' from dependencies to fix infinite loop

  const shuffleArray = (array) => {
    const arr = [...array];
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  };

  const showModal = () => {
    setOpen(true);
  };

  const hideModal = () => {
    setOpen(false);
  };

  const nextStep = async () => {
    // Handle both formats: array of objects with name property, or array of strings
    const guestNames = !cardData ? [] : 
      (typeof cardData[0] === 'string' ? cardData : cardData.map(guest => guest.name));
    
    let answer = "None";
    for (let i = 0; i < 3; i++) {
      if (guestNames.includes(problemNames[index][i])) {
        answer = problemNames[index][i];
        break;
      }
    }

    // Get user's answer - if selectedIndex is 3, they selected "None"
    const userAnswer = selectedIndex === 3 ? "None" : problemNames[index][selectedIndex];
    const isCorrect = answer === userAnswer;

    // Record the score (difficulty 2 for Module 4B, 1 point per correct answer)
    if (recordScore) {
      recordScore(isCorrect, {
        moduleKey: "name_recall",
        questionNumber: index + 1,
        totalQuestions: 12,
        userAnswer: userAnswer,
        correctAnswer: answer,
        options: [...problemNames[index], "None"]
      });
    }

    initialRes.B_nameRecognition.push({
      options: [...problemNames[index], "None"],
      correctAnswer: answer,
      userAnswer: userAnswer,
      isCorrect: isCorrect,
    })

    if (index === 11) {
      // Final question - complete module
      if (handleModuleComplete) {
        const correctAnswers = initialRes.B_nameRecognition.filter(answer => answer.isCorrect).length;
        // Delay handleModuleComplete to allow score popup to display
        setTimeout(() => {
          handleModuleComplete({
            moduleKey: "name_recall",
            totalQuestions: 12,
            correctAnswers,
            percentageScore: (correctAnswers / 12) * 100,
            difficulty: 1
          });
        }, 2500);
      } else {
        // Original behavior for non-scoring mode
        // Module 4B completed - original mode
        console.log('Module 4B completed', initialRes);
        nextPage();
      }
    } else {
      console.log(initialRes)
      setIndex(index + 1);
      setSelectedIndex(-1);
      setSelectedNames(problemNames[index + 1]);
    }
  }

  return (
    <div className="module1-main">
      <div className="module1-wrap">
        <Progress number="04." percent={1 / 2} />
        <div className="module1-content-wrap">
          <div className="module1-logo">Module 4</div>
          <div className="module1-body">
            <div className="module1-title">Which name was a name of one of the guests?</div>
          </div>
        </div>
      </div>

      <div className="module1-categories"></div>
      <div className="module1-dishes module1-dishes2 module3-dishes">
        {selectedNames.map((name, i) => (
          <div
            key={i}
            className="module1-dish module6-dish"
            onClick={() => setSelectedIndex(i)}
            style={{ background: selectedIndex === i ? "#F277C6" : "" }}
          >
            {problemNames[index][i]}
          </div>
        ))}
        <div
          className="module1-dish module6-dish"
          onClick={() => setSelectedIndex(3)}
          style={{ background: selectedIndex === 3 ? "#F277C6" : "" }}
        >
          None
        </div>
      </div>

      <div className='next-btn-group'>
        <div className='help-btn-group'>
          <div className='help-btn-effect1'></div>
          <div className='help-btn-effect2'></div>
          <img src={HelpBtn} onClick={() => showModal()} />
          <div className='help-content'>Do you need help?</div>
        </div>

        {selectedIndex !== -1 && (
          <div
            className="assessment-next-btn"
            onClick={() => { nextStep() }}
          >
            Next{" "}
            <div
              style={{
                paddingTop: "5px",
                display: "inline-block",
              }}
            >
              <FaChevronRight color="white" size={16} />
            </div>
          </div>
        )}
      </div>

      <Modal
        open={open}
        onOk={() => showModal()}
        onCancel={() => hideModal()}
        closeIcon={<img src={Close}></img>}
        footer={null}
      >
        <div className="direction-modal-container">
          <div className='direction-modal-title'>Directions</div>
          <div className='direction-modal-content'>
            During dinner, you overhear snippets of conversation and catch various names being mentioned. Your job is to determine which of the names you hear were actually names of guests sitting at your table. Click "Next" to test your ability to recall names!
          </div>
        </div>
      </Modal>
    </div>
  )
}

// Scored wrapper for Module 4B
export const ScoredModule4_4 = (props) => (
  <AssessmentWrapper 
    moduleType="4B" 
    isAdaptive={false}
    onModuleComplete={props.onModuleComplete}
  >
    <Module4_4Content {...props} />
  </AssessmentWrapper>
);

export default function Index(props) {
  return <Module4_4Content {...props} />;
}
